import React from "react";

const QRCODEIcon = ({ width, height, color }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_520_1013" fill="white">
        <rect x="0.424805" width="8.25507" height="8.25507" rx="1" />
      </mask>
      <rect
        x="0.424805"
        width="8.25507"
        height="8.25507"
        rx="1"
        stroke="#D4AF37"
        strokeWidth="4"
        mask="url(#path-1-inside-1_520_1013)"
      />
      <mask id="path-2-inside-2_520_1013" fill="white">
        <rect x="13.8389" width="8.25507" height="8.25507" rx="1" />
      </mask>
      <rect
        x="13.8389"
        width="8.25507"
        height="8.25507"
        rx="1"
        stroke="#D4AF37"
        strokeWidth="4"
        mask="url(#path-2-inside-2_520_1013)"
      />
      <mask id="path-3-inside-3_520_1013" fill="white">
        <rect
          x="0.424805"
          y="14.4463"
          width="8.25507"
          height="8.25507"
          rx="1"
        />
      </mask>
      <rect
        x="0.424805"
        y="14.4463"
        width="8.25507"
        height="8.25507"
        rx="1"
        stroke="#D4AF37"
        strokeWidth="4"
        mask="url(#path-3-inside-3_520_1013)"
      />
      <path
        d="M10.7422 0V22.7014"
        stroke="#D4AF37"
        strokeWidth="2"
        stroke-dasharray="4 4"
      />
      <path
        d="M14.8716 14.4463V22.7014"
        stroke="#D4AF37"
        strokeWidth="2"
        stroke-dasharray="2 2"
      />
      <path
        d="M17.9688 13.4141V21.6691"
        stroke="#D4AF37"
        strokeWidth="2"
        stroke-dasharray="2 2"
      />
      <path
        d="M21.0623 14.4463V22.7014"
        stroke="#D4AF37"
        strokeWidth="2"
        stroke-dasharray="3 3"
      />
      <path
        d="M0 11.3506L21.6696 11.3506"
        stroke="#D4AF37"
        strokeWidth="2"
        stroke-dasharray="4 4"
      />
      <rect
        x="3.52026"
        y="3.0957"
        width="2.06377"
        height="2.06377"
        fill="#D4AF37"
      />
      <rect
        x="16.9375"
        y="3.0957"
        width="2.06377"
        height="2.06377"
        fill="#D4AF37"
      />
      <rect
        x="3.52026"
        y="17.542"
        width="2.06377"
        height="2.06377"
        fill="#D4AF37"
      />
    </svg>
  );
};

export default QRCODEIcon;
